export default __webpack_public_path__ + "static/media/AQuAA_DXC_Logo.231399f1.png";